export enum ControlsType {
  OrthographicControls = 1,
  PerspectiveControls = 2,
  PointerLock = 3,
  Photosphere = 4,
}
